import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthApiService } from '../../../services/api/authApi/auth-api.service';
import { ErrorCodes } from '../../enums';
import { AuthStore } from '../../../store/auth.store';
import { ILoginResponse, IRefreshTokenDTO, IResponse } from '../../interfaces';
import { helpers } from '../../utils/helpers';

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authApiService = inject(AuthApiService);
  const authStore = inject(AuthStore);
  return next(req).pipe(
    catchError((error) => {
      if (error.status === ErrorCodes.unauthorized && !error.url?.includes(authApiService.refreshPath)) {
        return authApiService.refreshToken(authStore.token()).pipe(
          switchMap((res: IResponse<IRefreshTokenDTO>) => {
            const USER: ILoginResponse = {
              ...authStore.user(),
              token: res.data
            }
            authStore.setUser(USER);
            return next(helpers.setHttpHeaders(req, res?.data.accessToken));
          }),
          catchError((error) => {

            return throwError(() => ({
              ...error,
              status: ErrorCodes.unauthorized
            }));
          })
        );
      }
      return throwError(() => error);
    })
  );
};
